import { render, staticRenderFns } from "./LimitGoodsItem.vue?vue&type=template&id=221dfa73&scoped=true"
import script from "./LimitGoodsItem.vue?vue&type=script&lang=js"
export * from "./LimitGoodsItem.vue?vue&type=script&lang=js"
import style0 from "./LimitGoodsItem.vue?vue&type=style&index=0&id=221dfa73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221dfa73",
  null
  
)

export default component.exports